import client from "./client";

/** The most frequently queued songs (Id, Title, Artist, OwnerId). */
export const getTopSongs = () => client.get("/Catalog/TopSongs").then((r) => r.data);

/** Searches titles, artists and lyrics. */
export const search = (term) =>
  client.get(`/Catalog/Search/${encodeURIComponent(term)}`).then((r) => r.data);

/** Songs sung in sessions this device's host ran, most recent first (empty without a host key). */
export const sungBefore = () => client.get("/Catalog/SungBefore").then((r) => r.data);
